/**
 * FeaturesSection Component
 * Landing page features grid
 */

import { FEATURES } from "./constants";

export const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 px-6 relative">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-4xl font-bold text-center text-primary mb-4">
          Everything You Need to Sell More
        </h2>
        <p className="text-center text-foreground/70 mb-12 max-w-xl mx-auto">
          Six powerful AI tools working together to transform your product
          visuals.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {FEATURES.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group p-6 rounded-2xl glass glass-hover transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                  <Icon className="text-primary" size={28} />
                </div>
                <h3 className="text-xl font-semibold text-primary mb-2">
                  {feature.title}
                </h3>
                <p className="text-foreground/60 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
